<template>
  <div id="app">
    <!-- {{$utils.timestampToStr(nowDate, 'Y/M/D h:m:s')}} -->
    <!-- 首页头部 -->
    <header-box :key="isChange"></header-box>
    <router-view v-if="isRouterAlive" :key="$route.path + $route.query.t" />
    <!-- 全局的按钮 -->
    <all-btn v-if="bol"></all-btn>
  </div>
</template>

<script>

import HeaderBox from '@public/header-box'
import { mapState, mapMutations } from 'vuex'
// import config from '@assets/config'
import AllBtn from '@public/all-btn'

let _czc = window._czc || ''
export default {
  name: 'App',
  computed: mapState({
    nowDate: state => state.common.nowDate,
    timeDifference: state => state.common.timeDifference,
    isChange: state => state.useData.isChange,
    nowTestStatus: state => state.proctor.nowTestStatus
  }),
  components: {
    HeaderBox,
    AllBtn
  },
  watch: {
    nowTestStatus: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (val && val.examId && val.magType && this.$route.query.examId) {
          if (val.examId === this.$route.query.examId) {
            let type = val.magType === 201 ? 3 : val.magType === 202 ? 4 : 1
            this.$router.replace({
              path: '/ExamSystemMiss',
              query: {
                type: type,
                examId: this.$route.query.examId
              }
            })
          }
        }
      }
    },
    // 但和服务器时间同步时，更新本地时间
    'timeDifference' () {
      let time = new Date().getTime() + this.timeDifference
      this.set_nowDate(time)
    },
    $route () {
      if (this.$route.name === 'OrganizeIndex' || this.$route.name === 'SocietyIndex') {
        this.bol = false
      } else  {
        this.bol = true
      }
      // 判断 _czc 有没有挂载，且当前环境是开发还是生产，测试的时候，使用开发环境，上线之前记得改成生产，避免消息发送错误
      if (_czc) {
        // 如果使用_trackPageview改写了已有页面的URL，建议在CNZZ的JS统计代码执行前先调用_setAutoPageview，将该页面的自动PV统计关闭，防止页面的流量被统计双倍。
        // _czc.push(['_trackPageview', contentUrl, refererUrl]);

        // 获取当前页面的信息
        let location = window.location

        // 代表当前路由地址
        let contentUrl = location.pathname + location.hash

        // 代表当前页面的母页面，不填，按母页面的来路计算，但是实际上是取不到母页面的
        let refererUrl = '/'
        // 发送统计事件，
        _czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  },
  data () {
    return {
      isRouterAlive: true,
      bol: true
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      // console.warn('触发了')
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    // 更新当前时间
    ...mapMutations([
      'set_nowDate'
    ]),
    // 初始化
    init () {
      // 挂载更新全局的当前时间一直随时间变化
      let time = new Date().getTime() + this.timeDifference
      this.set_nowDate(time)
      setInterval(() => {
        time = new Date().getTime() + this.timeDifference
        this.set_nowDate(time)
      }, 1000)
    },
    beforeunloadHandler () {
      this.beforeUnloadTime = new Date().getTime()
    },
    unloadHandler () {
      this.gapTime = new Date().getTime() - this.beforeUnloadTime
      if (this.gapTime <= 5) { // 判断是窗口关闭还是刷新，小于5代表关闭，否则就是刷新。
        localStorage.setItem('window.name1', '')
      }
    }
  },
  mounted () {
    let lang = (navigator.language || navigator.browserLanguage).toLowerCase()
    let language = 'en'
    if (lang.indexOf('zh') !== -1) {
      // 浏览器语言是中文
      language = 'zh'
    }
    this.$i18n.locale = this.$utils.cache('bloom:lang') ? this.$utils.cache('bloom:lang') : language
    this.$utils.cache('bloom:lang', this.$i18n.locale)
    window.addEventListener('beforeunload', () => this.beforeunloadHandler())
    window.addEventListener('unload', () => this.unloadHandler())
  },
  created () {
    this.init()
    // const version = config.version
    // if ((window.location.hash === '#/') && (this.$utils.cache('version') !== version)) {
    //   localStorage.clear()
    //   this.$utils.cache('version', version)
    // } else if ((window.location.hash === '#/')) {
    //   this.$utils.cacheClear()
    // }
  }
}
let beforeUnloadTime = 0
window.onbeforeunload = function () {
  beforeUnloadTime = new Date().getTime()
  localStorage.setItem('window.name1', '')
}
window.onunload = function () {
  let gapTime = new Date().getTime() - beforeUnloadTime
  if (gapTime <= 5) { // 判断是窗口关闭还是刷新，小于5代表关闭，否则就是刷新。
    localStorage.setItem('window.name1', '')
  }
}
</script>

<style lang="less">
@import './assets/less/common.less';
</style>

<style lang="less" scoped>
#app{
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue